import keyMirror from 'key-mirror';
import { createActions } from 'redux-actions';

export const constants = keyMirror({
    AI_SUMMARY_REQUEST: null,
    AI_SUMMARY_SUCCESS: null,
    AI_SUMMARY_FAILURE: null,

    AI_QUESTION_REQUEST: null,
    AI_QUESTION_SUCCESS: null,
    AI_QUESTION_FAILURE: null,

    AI_CLEAR_CHAT: null,

    AI_INCREMENT_REQUEST_COUNT: null,
    AI_RESET_HOURLY_COUNT: null,
    AI_RESET_DAILY_COUNT: null,
});

export const {
    aiSummaryRequest,
    aiSummarySuccess,
    aiSummaryFailure,
} = createActions(
    constants.AI_SUMMARY_REQUEST,
    constants.AI_SUMMARY_SUCCESS,
    constants.AI_SUMMARY_FAILURE,
);

export const {
    aiQuestionRequest,
    aiQuestionSuccess,
    aiQuestionFailure,
} = createActions(
    constants.AI_QUESTION_REQUEST,
    constants.AI_QUESTION_SUCCESS,
    constants.AI_QUESTION_FAILURE,
);

export const { aiClearChat } = createActions(constants.AI_CLEAR_CHAT);

export const {
    aiIncrementRequestCount,
    aiResetHourlyCount,
    aiResetDailyCount,
} = createActions(
    constants.AI_INCREMENT_REQUEST_COUNT,
    constants.AI_RESET_HOURLY_COUNT,
    constants.AI_RESET_DAILY_COUNT,
);
